import { Check, X } from 'lucide-react'
import { StatusPill } from '../../components/StatusPill'
import type { SalonRequest } from '../../types'

export function ConfirmationCard({ request, onClose }: { request: SalonRequest; onClose: () => void }) {
  return (
    <div className="sheet-backdrop sheet-backdrop--centered">
      <section className="confirmation-card" role="dialog" aria-modal="true" aria-labelledby="confirmation-title">
        <button className="icon-button confirmation-card__close" onClick={onClose} aria-label="Close confirmation"><X size={20} /></button>
        <div className="success-orbit" aria-hidden="true"><span><Check size={28} /></span></div>
        <p className="eyebrow">Request received</p>
        <h2 id="confirmation-title">A little comfort is on its way.</h2>
        <p className="muted">Your request has been saved. A discreet email notification is being delivered to your stylist.</p>
        <div className="tracking-ticket">
          <div><span>Tracking code</span><strong>{request.trackingCode}</strong></div>
          <StatusPill status={request.status} />
        </div>
        <p className="ticket-note">Keep this page open to see updates. Only requests made in this browser session appear here.</p>
        <button className="primary-button primary-button--full" onClick={onClose}>Back to concierge</button>
      </section>
    </div>
  )
}
